export default "__VITE_ASSET__CqcqeHNm__"